<mat-form-field>
  <input
    aria-label="Filter"
    matInput
    (keyup)="applyFilter($event.target.value)"
    i18n-placeholder="@@filter"
    placeholder="Filter"
  />
</mat-form-field>
<div class="table-container mat-elevation-z2">
  <table
    mat-table
    class="table-list"
    matSort
    matSortActive="name"
    matSortDirection="asc"
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="name">
      <th mat-header-cell i18n="@@name" *matHeaderCellDef mat-sort-header>
        Name
      </th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="phone">
      <th mat-header-cell i18n="@@phone" *matHeaderCellDef mat-sort-header>
        Phone Number
      </th>
      <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell i18n="@@email" *matHeaderCellDef mat-sort-header>
        E-mail
      </th>
      <td mat-cell *matCellDef="let element">{{ element.email }}</td>
    </ng-container>
    @if (adminType() === admType.BranchAdmin) {
    <ng-container matColumnDef="branch">
      <th mat-header-cell i18n="@@branch" *matHeaderCellDef mat-sort-header>
        Branch
      </th>
      <td mat-cell *matCellDef="let element">
        {{ !!element?.branch?.uuid ? element.branch.name : "- - -" }}
      </td>
    </ng-container>
    } @if (adminType() === admType.ChainAdmin) {
    <ng-container matColumnDef="chain">
      <th mat-header-cell i18n="@@chain" *matHeaderCellDef mat-sort-header>
        Chains
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element?.chains?.length > 0 ? element.chains.length : "( - )" }}
      </td>
    </ng-container>
    }
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns; let i = index"
      [style]="{
        'background-color': selectedRowIndex === i ? '#3a89cc40' : 'white'
      }"
      (click)="selectServiceman(row, i)"
    ></tr>
  </table>
</div>
